import { AfterContentInit, ComponentRef, Inject, Injector, OnDestroy, ViewChild, ViewContainerRef, Directive } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Directive()
export abstract class AbstractDialogComponent implements OnDestroy, AfterContentInit {
  @ViewChild('content', { read: ViewContainerRef, static: true }) viewContainerRef: ViewContainerRef

  componentRef: ComponentRef<any>

  constructor(
    protected injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngAfterContentInit() {
    if (!this.data.component) return

    const injector = Injector.create({
      providers: [{ provide: MAT_DIALOG_DATA, useValue: this.data.data }],
      parent: this.injector,
    })
    this.componentRef = this.viewContainerRef.createComponent(this.data.component, {
      injector: injector,
    })
    this.componentRef.hostView.detectChanges()
  }

  ngOnDestroy() {
    this.componentRef && this.componentRef.destroy()
  }
}
